import React from 'react';
import { setSetting } from '/imports/api/users';
import { useUser } from '/imports/hooks';
import { Icon } from '/imports/ui/Icon';
import { OrgSelect } from '/imports/ui/OrgSelect';
import { NotificationDrawer } from '/imports/ui/NotificationDrawer';

/**
 * Flip between the Arctic and Obsidian themes.
 *
 * Persists through the same `setSetting` method the profile page uses, so the
 * two stay in sync and there is only one source of truth. App.tsx reads
 * `user.settings.theme` and hands it to AppStyled, which puts `.dark` on
 * <html>, so no local state is needed here: the round trip through the user
 * document drives the whole tree.
 */
const ThemeToggle = () => {
  const user = useUser();
  const dark = (user?.settings?.theme || 'light') === 'dark';
  return (
    <button
      type="button"
      title={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => void setSetting.call({ key: 'theme', value: dark ? 'light' : 'dark' })}
      className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border-none bg-transparent text-fg-3 hover:bg-page-alt hover:text-fg-1"
    >
      {/* No dedicated light/dark glyphs exist in the icon map; modeOffOn is
          Material's mode-toggle icon, and the state is carried by the label. */}
      <Icon icon="modeOffOn" size={17} />
    </button>
  );
};

export const AppHeader = () => {
  return (
    <div className="app-header sticky top-0 z-2 flex min-h-app-header items-center gap-2 border-b border-soft bg-panel px-3 [&.print-mode]:hidden [&_.logo]:absolute [&_.logo]:top-3 [&_.logo]:right-4">
      <div className="org-select-wrapper flex flex-col justify-around mobile:mr-48 mobile:ml-16"><OrgSelect /></div>
      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />
        <div className="notification-wrapper flex flex-col justify-around"><NotificationDrawer /></div>
      </div>
    </div>
  );
};
